<template>
  <div>
    <div class="main pagebox">
      <div id="w_grid-1561969673372" class="w_grid-000">
        <div class="w_grid signal">
          <div class="e_box e_box-000 p_gridbox">
            <div id="content_box-1561969673372-0" class="e_box e_box-000 d_gridCell_0 p_gridCell">
              <div id="c_portalResnav_main-15834620458466587" class="c_portalResnav_main-01001002 allheader_common"
                style="height: 80px;">
                <el-row :gutter="10" class="allhc_menu">
                  <el-col :xs="0" :sm="24" class="menu_elcol">
                    <div class="pc_menu">
                      <div class="logo_img">
                        <img src="./assets/furuiImg/logo.jpg" style="margin-right: 10px;width: 100px;" alt="" />
                        <img src="./assets/furuiImg/logo1.jpg" style="margin-right: 10px;" alt="" />
                        <img src="./assets/furuiImg/logo2.jpg" style="margin-right: 20px;width: 100px;" alt="" />
                        <div class="company-name">
                          <p>福建省庆川数控机械有限公司</p>
                          <p>FUJIAN QINGCHUAN CNC MACHINERY CO., LTD.</p>
                        </div>
                      </div>
                      <div class="pc_menu_con">
                        <!-- 首页 -->
                        <div @click="toPages('home')" :class="{ menuActive: activeIndex === 0 }" class="menu_big">
                          {{ $t("user.login") }}
                        </div>
                        <!-- 关于庆川 -->
                        <div @click="toPages('aboutus')" :class="{ menuActive: activeIndex === 1 }"
                          style="position: relative;" @mouseenter="showLangage('aboutus')"
                          @mouseleave="handleMouseLeave('aboutus')" class="menu_big">
                          {{ $t("user.aboustus") }}
                          <div class="menu_sub" v-show="isAbout" style="position: absolute;top: 22px;color: black;">
                            <div class="menu_sub_title" @click.stop="toSection('aboutus', 'section1')"
                              :style="{ width: $i18n.locale === 'en' ? '200px' : '150px' }">{{
                                $t("user.chongqingcontent26") }}</div>
                            <div class="menu_sub_title" @click.stop="toSection('aboutus', 'section2')"
                              :style="{ width: $i18n.locale === 'en' ? '200px' : '150px' }">{{
                                $t("user.chongqingcontent28") }}</div>
                            <!-- <div class="menu_sub_title" @click.stop="toSection('aboutus', 'section3')"
                              :style="{ width: $i18n.locale === 'en' ? '200px' : '150px' }">{{
                                $t("user.aboutush3") }}</div> -->
                            <div class="menu_sub_title" @click.stop="toSection('aboutus', 'section4')"
                              :style="{ width: $i18n.locale === 'en' ? '200px' : '150px' }">{{
                                $t("user.chongqingcontent33") }}</div>
                            <div class="menu_sub_title" @click.stop="toSection('aboutus', 'section5')"
                              :style="{ width: $i18n.locale === 'en' ? '200px' : '150px' }">{{
                                $t("user.aboutust2") }}</div>
                            <div class="menu_sub_title" @click.stop="toSection('aboutus', 'section6')"
                              :style="{ width: $i18n.locale === 'en' ? '200px' : '150px' }">{{
                                $t("user.chongqingcontent34") }}</div>
                            <div class="menu_sub_title" @click.stop="toPages('management')"
                              :style="{ width: $i18n.locale === 'en' ? '200px' : '150px' }">{{ $t("user.management") }}
                            </div>
                          </div>
                        </div>
                        <!-- 产品中心 -->
                        <div @click="toPages('project')" :class="{ menuActive: activeIndex === 2 }"
                          style="position: relative;" @mouseenter="showLangage('project')"
                          @mouseleave="handleMouseLeave('project')" class="menu_big">
                          {{ $t("user.Products") }}
                          <div class="menu_sub" v-show="isProduct"
                            style="position: absolute;top: 22px;color: black;text-align: center;">
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '300px' : '150px' }">{{
                              $t("user.productst1") }}</div>
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '300px' : '150px' }">{{
                              $t("user.productst2") }}</div>
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '300px' : '150px' }">{{
                              $t("user.productst3") }}</div>
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '300px' : '150px' }">{{
                              $t("user.productst4") }}</div>
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '300px' : '150px' }">{{
                              $t("user.productst5") }}</div>
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '300px' : '150px' }">{{
                              $t("user.productst6") }}</div>
                          </div>
                        </div>
                        <!-- 应用领域 -->
                        <div @click="toPages('uselocation')" :class="{ menuActive: activeIndex === 3 }"
                          style="position: relative;" @mouseenter="showLangage('uselocation')"
                          @mouseleave="handleMouseLeave('uselocation')" class="menu_big">
                          {{ $t("user.Uselocation") }}
                          <div class="menu_sub" v-show="isUselocation"
                            style="position: absolute;top: 22px;color: black;text-align: center;">
                            <div class="menu_sub_title">{{ $t("user.uselocationt2") }}</div>
                            <div class="menu_sub_title">{{ $t("user.uselocationt3") }}</div>
                            <div class="menu_sub_title">{{ $t("user.uselocationt4") }}</div>
                            <div class="menu_sub_title">{{ $t("user.uselocationt5") }}</div>
                          </div>
                        </div>
                        <!-- 新闻资讯 -->
                        <div @click="toPages('news')" :class="{ menuActive: activeIndex === 4 }"
                          style="position: relative;" @mouseenter="showLangage('news')"
                          @mouseleave="handleMouseLeave('news')" class="menu_big">
                          {{ $t("user.News") }}
                          <div class="menu_sub" v-show="isNews"
                            style="position: absolute;top: 22px;color: black;text-align: center;">
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '250px' : '150px' }">{{
                              $t("user.newst1") }}</div>
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '250px' : '150px' }">{{
                              $t("user.newst2") }}</div>
                            <div class="menu_sub_title" :style="{ width: $i18n.locale === 'en' ? '250px' : '150px' }">{{
                              $t("user.newst3") }}</div>
                          </div>
                        </div>
                        <!-- 社会责任 -->
                        <div @click="toPages('SResponsibility')" :class="{ menuActive: activeIndex === 5 }"
                          class="menu_big">
                          {{ $t("user.socianl") }}
                        </div>
                        <!-- 联系我们 -->
                        <div @click="toPages('contactus')" :class="{ menuActive: activeIndex === 6 }" class="menu_big">
                          {{ $t("user.Contactus") }}
                        </div>
                        <!-- 语言版本 -->
                        <div :class="{ menuActive: activeIndex === 7 }" style="position: relative;"
                          @mouseenter="showLangage('language')" class="menu_big"
                          @mouseleave="handleMouseLeave('language')">
                          {{ $t("user.Language") }}
                          <div class="menu_sub" v-if="isShowlan"
                            style="position: absolute;top: 22px;color: black;text-align: center;">
                            <div class="menu_sub_title" @click="changeLanguage('zh')">
                              中文
                            </div>
                            <div class="menu_sub_title" @click="changeLanguage('en')">
                              English
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :xs="24" :sm="0">
                    <div class="mobile_menu">
                      <el-button @click="drawer = true" type="primary" custom-class="mobilemenuBtn"
                        style="margin-left: 16px">
                        <i class="el-icon-s-fold"></i>
                      </el-button>
                      <el-drawer size="50%" custom-class="momenuDrawer" :visible.sync="drawer" :append-to-body="true"
                        :direction="direction" :before-close="handleClose">
                        <div class="jumpBtn" :class="{ momenuActive: activeIndex === 0 }" @click="toPages('home')">
                          {{ $t("user.login") }}
                        </div>
                        <div class="qiege_line"></div>
                        <div class="jumpBtn" :class="{ momenuActive: activeIndex === 1 }" @click="toPages('aboutus')">
                          {{ $t("user.aboustus") }}
                        </div>
                        <div class="qiege_line"></div>
                        <div class="jumpBtn" :class="{ momenuActive: activeIndex === 2 }" @click="toPages('project')">
                          {{ $t("user.Products") }}
                        </div>
                        <div class="qiege_line"></div>
                        <div class="jumpBtn" :class="{ momenuActive: activeIndex === 3 }" @click="toPages('contactus')">
                          <a href=""></a>{{ $t("user.Contactus") }}
                        </div>
                        <div class="qiege_line"></div>
                        <div class="jumpBtn lanChanBtn" @click="changeLanguage('zh')">
                          {{ $t("user.Chinese") }}
                        </div>
                        <div class="qiege_line"></div>
                        <div class="jumpBtn lanChanBtn" @click="changeLanguage('en')">
                          {{ $t("user.English") }}
                        </div>
                      </el-drawer>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="head_box">
                <!-- banner轮播图· -->
                <el-carousel indicator-position="outside" height="650px" :indicator-position="none">
                  <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                    <!-- <img :src="item.imgUrl" alt="" style="object-fit: fit;width: 100%;height: 100%;cursor: pointer;"
                      @click="openImage(item.imgUrl)" /> -->
                    <el-image :src="item.imgUrl" alt="" style="object-fit: fit;width: 100%;height: 100%;"
                      :preview-src-list="[item.imgUrl]" />
                  </el-carousel-item>
                </el-carousel>
              </div>
              <transition name="fade">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- 脚底 -->
      <div id="w_grid-1583471753649" class="w_grid-000 foor_common"
        style="padding-top: 30px;display: flex;flex-direction: row;padding: 30px 4vw;justify-content: space-between;">
        <!-- <div style="padding: 0 100px;">
          <div style="color: white;font-size: 20px;">首页/完整产业链一站式服务</div>
          <div class="heng_line" v-if="!isMobile"></div>
        </div> -->
        <div
          style="display: flex;justify-content: space-between;color: white;padding-top: 10px;cursor: pointer;width: 60%;">
          <!-- 首页 -->
          <div @click="toPages('home')" style="text-align: center;">
            {{ $t("user.login") }}
          </div>
          <!-- 关于庆川 -->
          <div @click="toPages('aboutus')" style="text-align: center;">
            {{ $t("user.aboustus") }}
            <div class="pd_top10">
              <div @click.stop="toSection('aboutus', 'section1')" class="pd_top">{{
                $t("user.chongqingcontent26") }}</div>
              <div @click.stop="toSection('aboutus', 'section2')" class="pd_top">{{
                $t("user.chongqingcontent28") }}</div>
              <div @click.stop="toSection('aboutus', 'section4')" class="pd_top">{{
                $t("user.chongqingcontent33") }}</div>
              <div @click.stop="toSection('aboutus', 'section5')" class="pd_top">{{
                $t("user.aboutust2") }}</div>
              <div @click.stop="toSection('aboutus', 'section6')" class="pd_top">{{
                $t("user.chongqingcontent34") }}</div>
              <div @click.stop="toPages('management')" class="pd_top">{{
                $t("user.management") }}</div>
            </div>
          </div>
          <!-- 产品中心 -->
          <div @click="toPages('project')" style="text-align: center;">
            {{ $t("user.Products") }}
            <div class="pd_top10">
              <div class="pd_top">{{
                $t("user.productst1") }}</div>
              <div class="pd_top">{{
                $t("user.productst2") }}</div>
              <div class="pd_top">{{
                $t("user.productst3") }}</div>
              <div class="pd_top">{{
                $t("user.productst4") }}</div>
              <div class="pd_top">{{
                $t("user.productst5") }}</div>
              <div class="pd_top">{{
                $t("user.productst6") }}</div>
            </div>
          </div>
          <!-- 应用领域 -->
          <div @click="toPages('uselocation')" style="text-align: center;">
            {{ $t("user.Uselocation") }}
            <div class="pd_top10">
              <div class="pd_top">{{ $t("user.uselocationt2") }}</div>
              <div class="pd_top">{{ $t("user.uselocationt3") }}</div>
              <div class="pd_top">{{ $t("user.uselocationt4") }}</div>
              <div class="pd_top">{{ $t("user.uselocationt5") }}</div>
            </div>
          </div>
          <!-- 新闻资讯 -->
          <div @click="toPages('news')" style="text-align: center;">
            {{ $t("user.News") }}
            <div class="pd_top10">
              <div class="pd_top">{{
                $t("user.newst1") }}</div>
              <div class="pd_top">{{
                $t("user.newst2") }}</div>
              <div class="pd_top">{{
                $t("user.newst3") }}</div>
            </div>
          </div>
          <!-- 社会责任 -->
          <div @click="toPages('SResponsibility')" style="text-align: center;">
            {{ $t("user.socianl") }}
          </div>
          <!-- 联系我们 -->
          <div @click="toPages('contactus')" style="text-align: center;">
            {{ $t("user.Contactus") }}
          </div>
          <!-- 语言版本 -->
          <div style="text-align: center;">
            {{ $t("user.Language") }}
            <div class="pd_top10">
              <div @click="changeLanguage('zh')" class="pd_top">
                中文
              </div>
              <div @click="changeLanguage('en')" class="pd_top">
                English
              </div>
            </div>
          </div>
        </div>
        <div class="footerCommon"
          style="padding-bottom: 0;width: 35%;display: flex;flex-direction: row;padding: 0 0 0 40px;justify-content: space-between;">
          <!-- <div style="text-align: right;">
            <div>微信公众号</div>
            <img src="@/assets/furuiImg/qrcode.jpg" alt="" style="width: 60px;height: 60px;">
          </div> -->
          <div class="foot_one"
            style="display: flex;flex-direction: column;align-items: left;justify-content: space-evenly;height: 100%;">
            <div class="grid-content one_box">
              <div class="circle_box">
                <i class="el-icon-phone-outline"></i>
              </div>
              <span>15205927288 张先生</span>
            </div>
            <div class="grid-content one_box">
              <div class="circle_box">
                <i class="el-icon-message"></i>
              </div>
              <span>huangshi2191995@163.con</span>
            </div>
            <div class="grid-content one_box">
              <div class="circle_box">
                <i class="el-icon-location-outline"></i>
              </div>
              <span>{{ $t("user.chongqingcontent30") }}</span>
            </div>
          </div>
          <div style="text-align: right;">
            <div>
              <img src="@/assets/furuiImg/qrcode.jpg" alt="" style="width: 150px;height: 150px;margin-top: 10px;">
              <div style="margin-top: 10px;text-align: center;">(扫码进入公众号)</div>
            </div>
          </div>
        </div>
      </div>
      <div class="heng_line" v-if="!isMobile" style="margin-bottom: 0;"></div>
      <div class="foot_two"
        style="background-color: #000000;display: flex;align-items: center;justify-content: center;">
        <a href="https://beian.miit.gov.cn/">
          <div class="grid-content foot_copyright" style="color: #fff;">
            ©2015-2025福建省庆川数控机械有限公司版权所有闽ICP备19023246号-1
          </div>
        </a>
      </div>
    </div>
    <div class="image-preview-modal" v-if="isPreviewOpen" @click="closePreview">
      <div class="preview-content" @click.stop>
        <button class="close-btn" @click="closePreview">×</button>
        <img :src="currentPreviewImage" alt="预览图片" class="preview-image" :style="{
          maxHeight: `${maxPreviewHeight}px`, transform: transformStyle, transition: 'transform 0.2s ease'
        }" @mousedown="handleMouseDown" @mouseleave="handleMouseUp">
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/request/index.js";
import $ from "jquery";
import { getBannerList } from "@/api/index.js";
export default {
  data() {
    return {
      isAbout: false,
      isProduct: false,
      bannerList: [
        {
          imgUrl: require("@/assets/furuiImg/banner3.png"),
        },
        {
          imgUrl: require("@/assets/furuiImg/banner.png"),
        },
        {
          imgUrl: require("@/assets/furuiImg/banner3.jpg"),
        },
        {
          imgUrl: require("@/assets/furuiImg/banner2.jpg"),
        }
      ],
      isUselocation: false,
      isNews: false,
      isShow: false,
      isMobile: false,
      mobileMenuShow: false,
      isShowlan: false,
      drawer: false,
      direction: "rtl",
      activeIndex: 0, // 默认第一个菜单项激活
      language: localStorage.getItem("languageSet") || "zh",
      currentImage: '',
      isPreviewOpen: false,
      currentPreviewImage: '',
      maxPreviewHeight: 0,
      scale: 1, // 缩放比例，初始为1（100%）
      minScale: 0.5, // 最小缩放比例
      maxScale: 3,// 最大缩放比例
      x: 0, // 图片初始x坐标
      y: 0, // 图片初始y坐标
      isDragging: false, // 标记鼠标是否处于拖拽状态
      startX: 0, // 鼠标按下时的x坐标
      startY: 0 // 鼠标按下时的y坐标
    };
  },
  created() {
    console.log("获取到的路由" + this.$route.path);
    this.restoreActiveIndex(this.$route.path);
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    // jquery 代码块
    // banner图片上面的文字特效

    // 导航栏代码
    // $(".btn_nav").click(function () {
    //   console.log("触发了点击");
    //   $(".pc_nav").toggleClass("cur");
    // });

    $(window).scroll(function () {
      var sTop = $(window).scrollTop();
      if (sTop > 10) {
        $(".pc_menu").addClass("curr");
      } else {
        $(".pc_menu").removeClass("curr");
      }
    });
    this.maxPreviewHeight = window.innerHeight * 0.8;
    window.addEventListener('resize', this.handleResize);
    // this.getBannerList();
  },
  beforeDestroy() {
    // 组件销毁前移除滚动事件监听
    // window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    this.$bus.$off('openImage')
  },
  computed: {
    transformStyle() {
      return `translate(${this.x}px, ${this.y}px) scale(${this.scale})`;
    }
  },
  methods: {
    // 获取轮播图
    async getBannerList() {
      let res = await getBannerList();
      console.log(res);
      this.bannerList = res.data;
    },
    restoreActiveIndex(routePath) {
      switch (routePath) {
        case "/":
          this.activeIndex = 0;
          if (this.drawer == true) {
            this.drawer = !this.drawer;
          }
          break;
        case "/aboutus":
          this.activeIndex = 1;
          if (this.drawer == true) {
            this.drawer = !this.drawer;
          }

          break;
        case "/product":
          this.activeIndex = 2;
          if (this.drawer == true) {
            this.drawer = !this.drawer;
          }
          break;
        case "/contact":
          this.activeIndex = 3;
          if (this.drawer == true) {
            this.drawer = !this.drawer;
          }
          break;
        default:
          // 默认执行代码
          if (routePath.includes("frProductDetail")) {
            console.log("进入这里");
            this.activeIndex = 2;
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            break;
          }
          this.activeIndex = 0;
          if (this.drawer == true) {
            this.drawer = !this.drawer;
          }
          break;
      }
    },
    handleClose(done) {
      done();
    },
    showLangage(type) {
      if (type === 'aboutus') {
        this.isAbout = true;
      } else if (type === 'project') {
        this.isProduct = true;
      } else if (type === 'uselocation') {
        this.isUselocation = true;
      } else if (type === 'news') {
        this.isNews = true;
      } else if (type === 'language') {
        this.isShowlan = true;
      }
    },
    handleMouseLeave(type) {
      if (type === 'aboutus') {
        this.isAbout = false;
      } else if (type === 'project') {
        this.isProduct = false;
      } else if (type === 'uselocation') {
        this.isUselocation = false;
      } else if (type === 'news') {
        this.isNews = false;
      } else if (type === 'language') {
        this.isShowlan = false;
      }
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    handleMenu() {
      console.log("触发了点击");
    },
    toPages(type) {
      switch (type) {
        case "home":
          // 执行代码
          if (this.$router.currentRoute.path !== "/") {
            console.log();
            this.activeIndex = 0;
            // sessionStorage.setItem("activeIndex", 0);
            this.$router.push("/");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }
          // this.$router.push({ name: "home" });
          break;
        case "aboutus":
          // 执行代码
          if (this.$router.currentRoute.path !== "/aboutus") {
            this.activeIndex = 1;
            // sessionStorage.setItem("activeIndex", 1);
            this.$router.push("/aboutus");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }

          break;
        case "project":
          // 执行代码
          if (this.$router.currentRoute.path !== "/product") {
            this.activeIndex = 2;
            // sessionStorage.setItem("activeIndex", 2);
            this.$router.push("/product");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }
          // this.$router.push("product");
          break;
        case "contactus":
          // 执行代码
          if (this.$router.currentRoute.path !== "/contact") {
            this.activeIndex = 6;
            // sessionStorage.setItem("activeIndex", 3);
            this.$router.push("/contact");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }
          // this.$router.push("contact");
          break;
        case "uselocation":
          // 执行代码
          if (this.$router.currentRoute.path !== "/uselocation") {
            this.activeIndex = 3;
            // sessionStorage.setItem("activeIndex", 4);
            this.$router.push("/uselocation");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }
          // this.$router.push("contact");
          break;
        case "news":
          // 执行代码
          if (this.$router.currentRoute.path !== "/news") {
            this.activeIndex = 4;
            // sessionStorage.setItem("activeIndex", 4);
            this.$router.push("/news");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }
          // this.$router.push("contact");
          break;
        case "SResponsibility":
          // 执行代码
          if (this.$router.currentRoute.path !== "/SResponsibility") {
            this.activeIndex = 5;
            // sessionStorage.setItem("activeIndex", 4);
            this.$router.push("/SResponsibility");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }
          // this.$router.push("contact");
          break;
        case "management":
          // 执行代码
          if (this.$router.currentRoute.path !== "/management") {
            this.activeIndex = 1;
            // sessionStorage.setItem("activeIndex", 4);
            this.$router.push("/management");
            if (this.drawer == true) {
              this.drawer = !this.drawer;
            }
            // window.location.reload();
          }
          // this.$router.push("contact");
          break;
        default:
        // 默认执行代码
        // this.activeIndex = 0;
        // if (this.$router.currentRoute.path !== "/") {
        //   this.$router.push("/");
        //   if (this.drawer == true) {
        //     this.drawer = !this.drawer;
        //   }
        //   // window.location.reload();
        // }
      }
    },
    toSection(pageType, sectionId) {
      this.closeAllSubMenus();
      const targetPath = this.getPathByType(pageType);
      // 拼接哈希：路径+#sectionId
      const targetUrl = `${targetPath}#${sectionId}`;

      // 如果已在目标页面，直接滚动
      console.log("当前路由" + this.$router.currentRoute.path, targetPath);
      if (this.$router.currentRoute.path === targetPath) {
        this.scrollToSection(sectionId);
        return;
      }
      this.toPages(pageType)
      // console.log("目标路由" + targetUrl);
      // // this.scrollToSection(sectionId);
      // this.$router.push(targetUrl)

      // this.updateActiveIndex(pageType);
      // if (this.drawer) this.drawer = false;
    },
    // 滚动到指定区域
    scrollToSection(sectionId) {
      // 使用$nextTick确保DOM已更新
      this.$nextTick(() => {
        const element = document.getElementById(sectionId);
        const absoluteTop = element + window.pageYOffset;
        // 减去需要偏移的距离（这里是80px）
        const targetPosition = absoluteTop;
        if (element) {
          // 平滑滚动到目标元素
          element.scrollIntoView({
            top: targetPosition,
            behavior: 'smooth',  // 平滑滚动
            block: 'start'       // 元素顶部与视口顶部对齐
          });
        }
      });
    },
    // 根据页面类型获取路径
    getPathByType(type) {
      const pathMap = {
        'home': '/',
        'aboutus': '/aboutus',
        'project': '/product',
        'contactus': '/contact',
        'uselocation': '/uselocation',
        'news': '/news',
        'SResponsibility': '/SResponsibility'
      };
      return pathMap[type] || '/';
    },
    // 更新活跃菜单索引
    updateActiveIndex(type) {
      const indexMap = {
        'home': 0,
        'aboutus': 1,
        'project': 2,
        'uselocation': 3,
        'news': 4,
        'SResponsibility': 5,
        'contactus': 6
      };
      this.activeIndex = indexMap[type] || 0;
    },
    // 关闭所有子菜单
    closeAllSubMenus() {
      this.isAbout = false;
      this.isProduct = false;
      this.isUselocation = false;
      this.isNews = false;
      this.isShowlan = false;
    },
    handleResize() {
      this.isMobile = document.documentElement.clientWidth < 768;
      this.$store.commit("SET_ISMOBILE", this.isMobile);
      this.maxPreviewHeight = window.innerHeight * 0.8;
    },
    changeLanguage(lang) {
      // console.log("中文英文切换", lang);
      if (lang === "en") {
        this.$i18n.locale = "en";
        localStorage.setItem("languageSet", this.$i18n.locale);
        if (this.drawer == true) {
          this.drawer = !this.drawer;
        }
      } else if (lang === "zh") {
        this.$i18n.locale = "zh";
        localStorage.setItem("languageSet", this.$i18n.locale);
        if (this.drawer == true) {
          this.drawer = !this.drawer;
        }
      }
      //先用刷新页面
      // window.location.reload();

      // this.$i18n.locale == 'zh' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'zh' //设置中英文模式
      // localStorage.setItem('languageSet', this.$i18n.locale) //将用户设置存储到localStorage以便用户下次打开时使用此设置
    },
    switchto(index) {
      // if (location.pathname == this.routerlist[index]) {
      // 	return
      // }
      // this.$router.push({
      // 	path: this.routerlist[index]
      // })
    },
    handleScroll() {
      // 获取滚动条位置
      const scrollPosition = window.scrollY;

      // 根据滚动条位置判断是否添加类名
      if (scrollPosition > 0) {
        this.isScrolled = true;
      } else {
        this.isScrolled = false;
      }
    },
    // 打开图片预览弹窗
    openImage(imageUrl) {
      this.currentPreviewImage = imageUrl;
      // console.log('aa', this.currentPreviewImage)
      this.isPreviewOpen = true;
      this.scale = 1;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
      document.addEventListener('wheel', this.handleWheel);
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    // 处理鼠标滚轮缩放
    closePreview() {
      this.isPreviewOpen = false;
      this.currentPreviewImage = '';
      // 恢复页面滚动
      document.body.style.overflow = '';
      document.removeEventListener('wheel', this.handleWheel);
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    },
    // 处理鼠标滚轮事件
    handleWheel(e) {
      e.preventDefault(); // 阻止事件冒泡和默认行为

      // 判断滚轮方向：deltaY为正向下滚（缩小），为负向上滚（放大）
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      let newScale = this.scale + delta;

      // 限制缩放范围在minScale和maxScale之间
      newScale = Math.max(this.minScale, Math.min(newScale, this.maxScale));

      // 更新缩放比例
      this.scale = newScale;
    },
    // 重置缩放比例为原始大小
    resetZoom() {
      this.scale = 1;
    },
    handleResize() {
      this.maxPreviewHeight = window.innerHeight * 0.8;
    },
    // 鼠标按下事件处理
    handleMouseDown(e) {
      this.isDragging = true;
      this.startX = e.clientX - this.x;
      this.startY = e.clientY - this.y;
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    // 鼠标移动事件处理
    handleMouseMove(e) {
      if (this.isDragging) {
        this.x = e.clientX - this.startX;
        this.y = e.clientY - this.startY;
      }
    },
    // 鼠标松开事件处理
    handleMouseUp() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    },
    watch: {
      $route(to) {
        if (this.targetSection) {
          this.scrollToSection(this.targetSection);
          // 重置目标区域
          this.targetSection = null;
        }
      }
    },
  },
};
</script>

<style lang="scss">
// 图片预览弹窗样式
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

.preview-content {
  position: relative;
  max-width: 100%;
}

.preview-image {
  max-width: 100%;
  object-fit: contain;
  cursor: pointer !important;
  transition: transform 0.3s ease;
}

// 关闭按钮样式
.close-btn {
  position: absolute;
  top: -40px;
  right: 0px !important;
  background: none;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: all 0.2s;
  z-index: 99999999;

  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
}

// 淡入动画
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.head_box {
  // width: 100%;
  // background: url(../assets/furuiImg/banner.jpg);
  height: 520px;
  // height: 700px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 80px;
}

.heng_line {
  width: 100%;
  height: 1px;
  background-color: white;
  margin: 0 auto;
}

.pd_top10 {
  padding-top: 10px;
}

.pd_top {
  margin-top: 10px;
}

.menu_big:hover {
  color: #56B275;
}

.menu_big:hover::after {
  color: #56B275;
  content: "";
  position: absolute;
  bottom: 0;
  height: 3px;
  /* Line height */
  background-color: #56B275;
  /* Line color */
  width: 30px;
  border-radius: 2px;
}

.company-name {
  /* 根据父容器宽度限制，避免无限制扩展 */
  max-width: 600px;
  min-width: 185px;
  /* 可根据实际布局调整宽度 */
  margin-top: 10px;
}

.company-name p {
  white-space: nowrap;
  /* 禁止文本换行 */
  overflow: hidden;
  /* 隐藏溢出内容 */
  text-overflow: ellipsis;
  /* 溢出部分显示... */
  margin: 0;
  /* 清除默认margin，避免换行 */
}


/* 定义过渡样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active for <=2.1.8 */
  {
  opacity: 0;
}

.mobile_menu {
  .el-button {
    padding: 8px !important;
    font-size: 25px;
  }

  .el-button--primary {
    background: #56B275;
  }

  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #56B275 !important;
    border-color: #56B275 !important;
  }
}

.momenuDrawer {
  background: #56B275 !important;

  .el-drawer__header {
    background: #56B275;
    margin-bottom: 0;
    padding-bottom: 20px;

    .el-drawer__close-btn {
      >i {
        color: white;
        font-size: 30px;
      }
    }
  }

  .el-drawer__body {
    background: #56B275;
  }

  .jumpBtn {
    width: 80%;
    height: 26px;
    line-height: 30px;
    font-size: 20px;
    color: white;
    margin: 10px auto;
  }

  .qiege_line {
    width: 80%;
    margin: 20px auto;
    height: 0.5px;
    background: #f0f0f0;
  }

  .lanChanBtn {
    color: white;
  }
}

.menu_sub_title {
  //margin-top: 10px;
  // padding: 0 30px;
  width: 150px;
  height: 35px;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.menu_sub_title:hover {
  background-color: #56B275;
  color: #fff;
  padding: 0;
}

.menu_sub {
  // background-color: rgba(102, 102, 102, 0.8);
  background-color: #fff;
  // padding: 10px;
  // color: #fff;
  margin-top: 20px;
}

.menu_sub:hover {
  color: #56B275;

}
</style>
<style lang="scss" scoped>
.curr {
  // background-color: rgba(102, 102, 102, 0.8);
  background-color: #fff;
}

.menuActive {
  color: #56B275;
}

.menuActive::after {
  content: "";
  position: absolute;
  bottom: 0;
  height: 3px;
  /* Line height */
  background-color: #56B275;
  /* Line color */
  width: 30px;
  border-radius: 2px;
}

.momenuActive {
  color: #8afbf6;
}

.allheader_common {
  width: 100%;
  height: 50px;

  .allhc_menu {
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .menu_elcol {
      width: 100%;
      height: 100%;
      padding: 0 !important;
    }

    .pc_menu {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-evenly;
      // align-items: center;
      transition: background-color 0.3s ease;
      //flex-direction: column;
      background-color: #fff;

      .logo_img {
        width: 50%;
        // height: 100%;
        display: flex;
        // align-items: center;
        padding-left: 100px;
        padding-top: 10px;

        >img {
          width: 50px;
          height: 50px;
        }
      }

      .pc_menu_con {
        display: flex;
        // justify-content: center;
        justify-content: space-evenly;
        width: 100%;
        align-items: center;
        // flex-direction: row;
        height: 100%;
        color: black;
        // margin-right: 50px;
        // padding-bottom: 20px;

        >div {
          height: 50%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          // padding: 0 10px;
          // margin: 0 20px;
          white-space: nowrap;
          cursor: pointer;
          padding-bottom: 10px;
          // padding: 20px;
        }

        .languageBtn {
          position: relative;

          .languageBox {
            display: flex;
            flex-direction: column;
            top: 100%;
            right: 0;
            position: absolute;
            height: 70px;
            width: 150px;
            background: white;

            .lanBtn {
              color: black;
              display: flex;
              align-items: center;
              padding-left: 10px;
              width: 100%;
              height: 50%;
            }

            .lanBtna:hover {
              background: #56B275;
            }

            .lanBtnb:hover {
              background: #56B275;
            }
          }
        }
      }
    }



    .mobile_menu {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-top: 10px;
      padding-right: 10px;

      .el-drawer__header {
        margin-bottom: 0 !important;
      }
    }
  }
}

.cur h1.fl img {
  max-width: 300px !important;
}

.foor_common {
  padding-top: 30px;
  background: #1B1B1B;
  // background: #56B275;
}

.c_portalResnav_main-01001002 .header1 nav li:hover>a {
  color: #56B275 !important;
}

.c_portalResnav_main-01001002 .hvr-left:before {
  background: #56B275 !important;
}

.footerCommon {
  @media (max-width: 768px) {
    .foot_copyright {
      white-space: normal;
    }

    .one_wechat {
      align-items: flex-start !important;
    }
  }

  @media (min-width: 768px) {
    .foot_copyright {
      white-space: nowrap;
    }
  }

  width: 100%;
  padding: 30px 100px;
  color: white;

  .foot_one {
    .one_wechat {
      display: flex;
      align-items: flex-end;
      flex-direction: column;

      // float: right;
      >img {
        height: 60px;
        width: 60px;
        margin-bottom: 10px;
      }

      >p {
        font-size: 12px;
      }
    }

    .foot_one_er {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .one_box {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }

    .circle_box {
      height: 40px;
      min-width: 40px;
      border-radius: 50%;
      border: 1px solid white;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 18px;

      >i {
        font-size: 20px;
      }
    }
  }




}

.foot_two {
  // margin-top: 30px;
  // padding-top: 50%;
  height: 80px;

  .foot_menu>p {
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
  }

  .foot_copyright {
    font-size: 16px;
    // justify-content: center;;
    // margin-left: 50%;
    // margin: 50% 50%;
  }

  .foot_menu {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .su_line {
      width: 1px;
      height: 16px;
      background: white;
      margin: 0 20px;
    }
  }
}

.c_portalResnav_main-01001002 .header2 .logo img {
  width: 33% !important;
}

.c_portalResnav_main-01001002 .header2 {
  background: #56B275 !important;
}

.footer .text p,
.footer .text a {
  font-weight: bold;
  color: #3f3e55;

  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
  -ms-transition: all 0.4s;
  -o-transition: all 0.4s;
  font-size: 14px;
  color: #95959d;
  line-height: 24px;
  text-align: justify;
  text-decoration: none;
}

.fr .f-cb2 {
  display: flex;
  justify-content: space-around;
  padding-right: 80px;
}

.foot_section .links_list a:not(:first-child)::before {
  content: "\2022";
  /* 使用 Unicode 编码表示小黑点 */
  color: #656565;
  /* 设置黑色 */
  display: inline-block;
  /* 将伪元素转换为块级元素，以便设置宽度和高度 */
  width: 3px;
  height: 3px;
  margin-right: 15px;
  /* 设置与链接之间的间距 */
}

.foot_section .links_list a {
  font-size: 14px;
  text-decoration: none;
  position: relative;
  font-weight: bold;
  color: #656565;
  line-height: 33px;
  padding-left: 10px;
  margin-left: 3px;
  opacity: 0.6;
}

.footer {
  width: 100%;
  padding: 28px 0 37px;
  background-color: #f7f6f4;
  position: relative;
  z-index: 102;
}

.footer .content {
  position: relative;
  height: 100%;
}

.content {
  width: 1280px;
  margin: 0 auto;
}

#header {
  width: 100%;
  min-width: 1280px;
  max-width: 100%;
  margin: auto;
  position: fixed;
  top: 43px;
  left: 0px;
  right: 0px;
  z-index: 9999;
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
}

.header {
  box-sizing: border-box;
  width: 90%;
  // min-width: 1280px;
  height: 82px;
  margin: auto;
  position: relative;
  background-size: cover;
  z-index: 100;
  background-color: white;
  border-radius: 10px;
  font-size: 14px;
  -webkit-transition: all 0.4s;
  font-weight: bold;
}

.fixed-width {
  border-radius: 0;
  width: 100%;
}

.topheader {
  top: 0 !important;
  max-width: 100% !important;
}

.weChat_img {
  position: absolute;
  top: -115px;
  left: -26%;
  width: 107px;
  height: 107px;

  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  z-index: 99;
  opacity: 0;
  filter: Alpha(opacity=0);
  -webkit-transform: scale(0, 1);
  transform: scale(0, 1);
  -webkit-transform-origin: top center;
  transform-origin: top center;
  will-change: opacity;
  -webkit-transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s;
  transition: transform 0.4s, opacity 0.4s, -webkit-transform 0.4s;
  padding: 5px;
}

.socials_wrap .weChat_img img {
  width: 100%;
  height: 100%;
}

.socials_wrap img:hover+.weChat_img {
  opacity: 1;
  filter: Alpha(opacity=100);
  -webkit-transform: scale(1, 1);
  transform: scale(1, 1);
  -moz-transform: scale(1, 1);
  -ms-transform: scale(1, 1);
  -o-transform: scale(1, 1);
}

#w_grid-1583825877988 {
  left: 0px !important;
  right: 0px !important;
}

.c_portalResnav_main-01001002 .header1 .nav-sub.active {
  -webkit-transform: scaleY(1);
  -ms-transform: scaleY(1);
  transform: scaleY(1);
  -webkit-transition: -webkit-transform 0.3s;
  transition: transform 0.3s;
}

.c_portalResnav_main-01001002 .header1 .nav-sub.active .n-nav-sub {
  opacity: 1;
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transform: translate(0, 0);
  -webkit-transition: all 0.2s 0.3s;
  transition: all 0.2s 0.3s;
}
</style>